<template>
    <fade-transition :delay="500" :duration="{enter: 1000, leave: 10}" appear>
        <li class="newsList" :key="news_.name">
            <article id=""
                     class="news post type-post status-publish format-standard has-post-thumbnail hentry category-uncategorized"
                     data-temp="template_parts-content-archive">
                <div class="headlineWrapper">
                    <h2 class="headline headline-h2">
                        <router-link :to="{name: 'news-detail', params: {detail: news_.slug}}"
                                     :key="news_.slug"
                                     v-html="news_.title.rendered"
                        >
                        </router-link>
                    </h2>
                </div>

                <div v-if="src.length" class="news__content">
                    <router-link :to="{name: 'news-detail', params: {detail: news_.slug}}"
                                 :key="news_.slug"
                                 class="news__link">
                        <img width="" height=""
                             :src="src"
                             class="news__thumbnail wp-post-image"
                             alt=""

                             sizes="">
                    </router-link>
                </div>
            </article>
        </li>
    </fade-transition>
</template>

<script>
    export default {
        props: ['news_', 'src'],
        data() {
            return {}
        },
        computed: {},
        created() {
        },
        mounted() {
        },
        watch: {},
        methods: {}
    }
</script>
